import InstructorList from '../../../components/InstructorList';
import UsageTracker from '../../../utils/UsageTracker';
import { mapShortProfessorToProfessor } from '../shortContentUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShortContentInstructors = ({
  short
}) => {
  const {
    contentId: shortId,
    professors,
    language
  } = short;
  const mappedProfessors = professors.map(mapShortProfessorToProfessor(language));
  const trackProfessorClick = (professorId, organisation, organisationUrl) => () => UsageTracker.trackStandalone('Learning Center Interaction', {
    action: 'professor-organisation-click',
    contentType: 'SHORTFORM',
    appearsIn: 'short-form-content',
    organisation,
    organisationUrl,
    professorId,
    shortId
  });
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(InstructorList, {
      handleOrganisationUrlClick: trackProfessorClick,
      headingMarginBlockEnd: "200",
      headingPaddingBlockStart: "0",
      language: language,
      listPaddingInlineMobile: "0",
      professors: mappedProfessors
    })
  });
};